// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2tJy3","title":"BackImages_title__OxF66","images":"BackImages_images__lcR1e"};